import { useEffect, useState } from 'react';
import { getListPrice } from 'src/common/hooks/widgets/fetchData';

/* Parameter to receive*/
export interface PropsFunc {
  currency: string;
  localeCode: string;
  countryCode: string;
  setRUPriceEssential: React.Dispatch<React.SetStateAction<number>>;
  setRUPriceStandard: React.Dispatch<React.SetStateAction<number>>;
  setTUPrice: React.Dispatch<React.SetStateAction<number>>;
  setFeePrice: React.Dispatch<React.SetStateAction<number>>;
}
/* Parameter to get price*/
export interface priceProps {
  partNumber: string;
  pricingIndicator: string;
  pricingModel: number;
  scaleQtyPrice: [
    {
      qty: number;
      price: number;
    },
  ];
}
/* Part numbers to get*/
const partsToQuery = [
  {
    partNumber: 'D0HYWZX',
  },
  {
    partNumber: 'D0HYXZX',
  },
  {
    partNumber: 'D0GSAZX',
  },
  {
    partNumber: 'D0HYYZX',
  },
];

export const usePrice = ({
  currency,
  localeCode,
  countryCode,
  setRUPriceEssential,
  setRUPriceStandard,
  setTUPrice,
  setFeePrice,
}: PropsFunc) => {
  const [priceFile, setPriceFile] = useState({} as priceProps[]);
  const [dataFetched, setDataFetched] = useState([]);

  useEffect(() => {
    if (currency && countryCode && dataFetched.length === 0) {
      fetchPrices();
    }
  }, [localeCode, countryCode, currency]);

  const fetchPrices = () => {
    const body: any = {
      currency: currency,
      countryCode3: countryCode,
      parts: partsToQuery,
    };
    getListPrice(
      `https://api.marketplace.ibm.com/purchase/catalog/resources/price/info`,
      body,
      'POST',
    )
      .then((data) => {
        if (data.parts && data.parts.length !== 0) {
          setPriceFile(data.parts);
          setDataFetched(data.parts);
        } else {
          setDataFetched([]);
          setRUPriceEssential(0);
          setRUPriceStandard(0);
          setTUPrice(0);
          setFeePrice(0);
        }
      })
      .catch((error) => {
        setDataFetched([]);
        if (error.response) {
          // Request made but the server responded with an error
          if (error.response.status === 404)
            console.log('price source: backup');
        } else if (error.request) {
          // Request made but no response is received from the server.
          console.log(error.request);
        } else {
          // Error occured while setting up the request
          console.log('Error', error.message);
        }
      });
  };

  useEffect(() => {
    if (priceFile.length) {
      const priceArray = priceFile.map((item) => ({
        [item.partNumber]: item.scaleQtyPrice[0].price,
      }));
      const priceObj = Object.assign({}, ...priceArray);
      setRUPriceEssential(priceObj.D0HYWZX);
      setRUPriceStandard(priceObj.D0HYXZX);
      setTUPrice(priceObj.D0GSAZX);
      setFeePrice(priceObj.D0HYYZX);
    }
  }, [priceFile]);
};
